import { render, staticRenderFns } from "./resultData.vue?vue&type=template&id=01fd0016&scoped=true&"
import script from "./resultData.vue?vue&type=script&lang=js&"
export * from "./resultData.vue?vue&type=script&lang=js&"
import style0 from "./resultData.vue?vue&type=style&index=0&id=01fd0016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd0016",
  null
  
)

export default component.exports